module.exports = __webpack_public_path__ + "static/media/glass-martini-alt.d59dc013.svg";